import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { IconButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { FicheProgrammeNomenclature } from '../Fiche/FicheProgrammeNomenclature';
import { FicheTrancheTravaux } from '../Fiche/FicheTrancheTravaux';
import { FicheProgrammePlanning } from '../Fiche/FicheProgrammePlanning';
import { FicheProgrammeAdministratif } from '../Fiche/FicheProgrammeAdministratif';
import { FicheProgramme } from '../Fiche/FicheProgramme';
import { FicheValidationCycleProgramme } from '../Fiche/FicheValidationCycleProgramme';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { Timeline } from '../Timeline/Timeline';
import { MessageBars } from '../Outils/MessageBars';
import { CarouselProgramme } from '../Carousel/CarouselProgramme';
import { DetailsListProgrammeNomenclatureOperis } from '../List/DetailsListProgrammeNomenclatureOperis';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { DataOperation } from '../../data/DataOperation.jsx';
import { Data } from '../../data/Data';

import './Identification.css';
import '../../css/immocom.css';
import { Panel, PanelType } from 'office-ui-fabric-react';
import PerimetreContext from '../../contexts/PerimetreContext';
import { EUIDetailsList } from '../EUI/EUIDetailsList';

export class IdentificationProgramme extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <IdentificationProgrammeWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class IdentificationProgrammeWithPerimetre extends Component {

    static contextType = PerimetreContext;

    constructor(props) {
        super(props);

        this.state = {
            programme: {},
            region: null,
            agence: null,
            periodeOuverture: {},
            listEngagementsParTrancheTravauxEtSousProduit: [],
            listCycleOperation: [],
            listOperations: [],
            listTrancheTravaux: [],
            listOperisNomenclature: [],
            photos: [],

            selectedIdCycleOperation: 0,

            idProgrammeSelectionne: 0,
            idTrancheTravauxSelectionne: 0,
            idRegionTrancheTravaux: 0,
            idAgenceTrancheTravaux: 0,

            onAffichePanelProgrammePlanning: false,
            onAffichePanelProgrammeAdministratif: false,
            onAffichePanelTrancheTravaux: false,
            onAffichePanelProgramme: false,
            onAffichePanelValidationCycleOperation: false,

            onPeutChargerLeComposantFicheProgrammePlanning: false,
            onPeutChargerLeComposantFicheProgrammeAdministratif: false,

            expandBlocAdministratif: false,
            expandBlocEngagement: false,
            expandBlocPlanning: false,

            redirectionVersListeOperations: false,
            redirectionVersIdentificationOperation: false,

            enCoursDeTraitement: false,
            messageEnCoursTraitement: '',

            //chargementPhotosEnCours: false,

            hideMessageBarError: true,
            errorMessage: '',
            hideMessageBarWarning: true,
            warningMessage: ''
        }

        //#region chargement des columns
        let columnsTemp = [];
        columnsTemp.push({
            key: 'ids',
            name: 'IDs',
            ariaLabel: 'IDs',
            fieldName: 'ids',
            minWidth: 75,
            maxWidth: 75,
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            onRender: (item) => {
                const { idProgramme, idTrancheTravaux, idOperation } = item;
                const ids = `${idProgramme || "-"}/${idTrancheTravaux || "-"}/${idOperation || "-"}`;
                return <span title={ids}>{ids}</span>;
            }
        });
        columnsTemp.push({
            key: 'produit',
            name: 'Produit',
            ariaLabel: 'Produit',
            fieldName: 'produit',
            minWidth: 75,
            maxWidth: 100,
            isResizable: true,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            onRender: (item) => {
                const produit = item.produit;
                return <span title={produit}>{produit}</span>;
            }
        });
        columnsTemp.push({
            key: 'sousProduit',
            name: 'Sous produit',
            ariaLabel: 'Sous produit',
            fieldName: 'sousProduit',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            onRender: (item) => {
                const sousproduit = item.sousProduit;
                return <span title={sousproduit}>{sousproduit}</span>;
            }
        });
        columnsTemp.push({
            key: 'nomCommercial',
            name: 'Nom commercial',
            ariaLabel: 'Nom commercial',
            fieldName: 'nomCommercial',
            minWidth: 100,
            maxWidth: 300,
            isResizable: true,
            onRender: (item) => {
                let nomCommercial = item.nomCommercial;
                return <span title={nomCommercial}>{nomCommercial}</span>;
            }
        });
        columnsTemp.push({
            key: 'cycleOperation',
            name: 'Cycle opération',
            ariaLabel: 'Cycle opération',
            fieldName: 'cycleOperation',
            minWidth: 150,
            maxWidth: 180,
            isResizable: true,
            onRender: (item) => {
                let cycleOperation = item.dernierCycleOperation;
                let classBadge = Immocom.getBadgeCycleOperation(item.idDernierCycleOperation);

                return <span title={cycleOperation} className={"badge badge-" + classBadge}>{cycleOperation}</span>;
            }
        });
        columnsTemp.push({
            key: 'cycleCommercial',
            name: 'Cycle commercial',
            ariaLabel: 'Cycle commercial',
            fieldName: 'cycleCommercial',
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            minWidth: 100,
            maxWidth: 120,
            isResizable: true,
            onRender: (item) => {
                let cycleCommercial = item.dernierCycleCommercial;

                return <span title={cycleCommercial} className="badge badge-secondary">{cycleCommercial}</span>;
            }
        });
        columnsTemp.push({
            key: 'shab',
            name: 'SHAB',
            ariaLabel: 'SHAB',
            fieldName: 'shab',
            minWidth: 60,
            maxWidth: 100,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let shab = item.shab;
                return (shab !== null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(shab, false, 2) + ' m²'}</span> : null);
            }
        });
        columnsTemp.push({
            key: 'prixMetreCarre',
            name: 'Prix HT au m²',
            ariaLabel: 'Prix HT au m²',
            fieldName: 'prixMetreCarre',
            minWidth: 60,
            maxWidth: 100,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let prixMetreCarre = item.prixHTAuMCarre;
                return (prixMetreCarre !== null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(prixMetreCarre, false, 2) + ' €'}</span> : null);
            }
        });
        columnsTemp.push({
            key: 'nbLotsUnitairesAppartementOuMaison',
            name: 'Nb lots',
            ariaLabel: 'Nombre de lots',
            fieldName: 'nbLotsUnitairesAppartementOuMaison',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let nbreLots = item.nbLotsUnitairesAppartementOuMaison;
                return <span>{nbreLots}</span>;
            }
        });
        columnsTemp.push({
            key: 'nbLotsUnitairesAppartementOuMaisonEnStock',
            name: 'En stock',
            ariaLabel: 'En stock',
            fieldName: 'nbLotsUnitairesAppartementOuMaisonEnStock',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let nbreStock = item.nbLotsUnitairesAppartementOuMaisonEnStock;
                return <span>{nbreStock}</span>;
            }
        });
        columnsTemp.push({
            key: 'nbLotsUnitairesAppartementOuMaisonReserves',
            name: 'Réservés',
            ariaLabel: 'Réservés',
            fieldName: 'nbLotsUnitairesAppartementOuMaisonReserves',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let nbreResa = item.nbLotsUnitairesAppartementOuMaisonReserves;
                return <span>{nbreResa}</span>;
            }
        });

        columnsTemp.push({
            key: 'nbLotsUnitairesAppartementOuMaisonReservesActes',
            name: 'Réservés actés',
            ariaLabel: 'Réservés actés',
            fieldName: 'nbLotsUnitairesAppartementOuMaisonReservesActes',
            minWidth: 60,
            maxWidth: 100,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let nbreReservesActes = item.nbLotsUnitairesAppartementOuMaisonReservesActes;
                return <span>{nbreReservesActes}</span>;
            }
        });
        columnsTemp.push({
            key: 'qpei',
            name: 'Quote-part',
            ariaLabel: 'Quote-part',
            fieldName: 'qpei',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let qpei = item.qpei;
                return <span>{qpei} %</span>;
            }
        });
        columnsTemp.push({
            key: 'engagementInitialNb',
            name: 'Engagement',
            ariaLabel: 'Engagement',
            fieldName: 'engagementInitialNb',
            minWidth: 60,
            maxWidth: 100,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let engagementInitialNb = item.engagementInitialNb;
                return <span>{engagementInitialNb}</span>;
            }
        });
        columnsTemp.push({
            key: 'identification',
            name: '',
            ariaLabel: 'Accéder à l\'identification',
            fieldName: 'identification',
            minWidth: 20,
            maxWidth: 20,
            iconName: '',
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                if (item.idOperation !== null) {
                    return <IconButton
                        iconProps={{ iconName: 'Home' }}
                        title="Identification de l'opération"
                        ariaLabel="Identification de l'opération"
                        onClick={() => this._redirectionVersIdentificationOperation(true, item.idRegion, item.idAgence, item.idProgramme, item.idOperation)}
                    />;
                }
            }
        });
        this.columns = columnsTemp;
        //#endregion
    }

    _creationContent = () => {
        return this._creationSectionIdentification();
    }

    _creationSectionEngagement = () => {

        const { listEngagementsParTrancheTravauxEtSousProduit } = this.state;

        const currencyFormat = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });

        let content = [];
        let detailsList = undefined;
        let items = [];
        let idTrancheTravauxEnCours = 0;

        listEngagementsParTrancheTravauxEtSousProduit.forEach((p, index) => {

            if (p.idTrancheTravaux !== idTrancheTravauxEnCours) {
                if (!!detailsList) content.push(detailsList);
                content.push(
                    <div key={`${index}-trancheTravaux`} className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 labelTrancheTravaux">{p.trancheTravaux}</div>
                    </div>
                );
                items = [
                    { label: "Eng. initial surface (SDP / SU)", value: !!p.sha || p.sha === 0 ? `${parseFloat(p.sha).toFixed(2)} m²` : null },
                    { label: "Eng. initial CA", value: !!p.engagementInitialCA || p.engagementInitialCA === 0 ? currencyFormat.format(p.engagementInitialCA) : null },
                ];
                idTrancheTravauxEnCours = p.idTrancheTravaux;
            }

            items.push({ label: p.sousProduit, value: !!p.engagementInitialNb > 0 && `${p.engagementInitialNb} ${p.idProduit === 1 || p.idProduit === 3 || p.idProduit === 9 ? " lots" : ""}` });

            detailsList = <EUIDetailsList
                compact
                columns={[{ key: "label" }, { key: "value" }]}
                hideCommandBar
                hideHeader
                items={items}
                key={`${index}-list`}
                selectionMode={SelectionMode.none}
                wrapInScrollablePane={false}
            />;

            if (index === listEngagementsParTrancheTravauxEtSousProduit.length - 1) content.push(detailsList);

        });

        return content;

    };

    _creationSectionIdentification = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-lg3">
                    <div className="ms-Grid blocIdentification blocProgrammeNomenclature">
                        {/* Section : nomenclature */}
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12">
                                <Stack horizontal horizontalAlign="space-between">
                                    <div className="titreEncart">
                                        <Icon iconName="EMI" className="mr-2" />Nomenclature
                                    </div>
                                    <IconButton name="btnEditProgrammeNomenclature" iconProps={{ iconName: 'Edit' }} title="Modifier" onClick={this._onAffichePanelProgrammeNomenclature} />
                                </Stack>
                            </div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">Région :</div>
                            <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">{this.state.region}</div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">Agence :</div>
                            <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">{this.state.agence}</div>
                        </div>
                    </div>
                    {/* Section : engagement */}
                    <div className={this.state.expandBlocEngagement ? "ms-Grid blocIdentification niveau3 blocProgrammeEngagementExpand" : "ms-Grid blocIdentification niveau3 blocProgrammeEngagement"}>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12">
                                <Stack horizontal horizontalAlign="space-between">
                                    <div className="titreEncart">
                                        <Icon iconName="Commitments" className="mr-2" />Engagement
                                    </div>
                                </Stack>
                            </div>
                        </div>
                        <Icon
                            className="iconeCollapse"
                            title={this.state.expandBlocEngagement ? "Masquer" : "Afficher"}
                            onClick={() => this.setState({ expandBlocEngagement: !this.state.expandBlocEngagement })}
                            iconName={this.state.expandBlocEngagement ? "ChevronUp" : "ChevronDown"}
                        />
                        {this._creationSectionEngagement()}
                        <hr />
                        {/* Section : Nomenclature Opéris */}
                        <div className="blocNomenclatureOperis">
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12">
                                    <Stack horizontal horizontalAlign="space-between">
                                        <div className="titreEncart">
                                            <Icon iconName="EMI" className="mr-2" />Nomenclature Opéris
                                        </div>
                                        <IconButton name="btnEditProgrammeNomenclatureOperis" iconProps={{ iconName: 'Edit' }} title="Modifier" onClick={this._onAfficheListeProgrammeNomenclatureOperis} />
                                    </Stack>
                                </div>
                            </div>
                            {this._rendrerNomenclatureOperis()}
                        </div>
                    </div>

                </div>

                <div className="ms-Grid-col ms-sm12 ms-lg5">
                    <div className="ms-Grid">
                        <div className="ms-Grid blocIdentification blocProgrammeTimeline">
                            {/* Section : timeline */}
                            <Timeline listeEtapes={this.state.listCycleOperation} etapeActive={0} sansContainer={true} />
                        </div>
                        <div className="ms-Grid-row blocIdentificatioPrincipal">
                            <div className="ms-Grid-col ms-sm12 divEncartIdentificationPrincipal divEncartIdentificationPrincipalProgramme">
                                <Stack horizontal>
                                    {/* Titre + adresse */}
                                    <Stack.Item grow>
                                        <div className="titreEncart">
                                            <Icon iconName="Home" /> {this.state.programme.programme}
                                        </div>
                                        {this.state.programme.adresse} {this.state.programme.complementAdresse !== null && this.state.programme.complementAdresse !== undefined ? `, ${this.state.programme.complementAdresse}` : ''} - {this.state.programme.cp} {this.state.programme.ville}
                                    </Stack.Item>
                                    {/* Edition */}
                                    <Stack horizontal>
                                        <IconButton iconProps={{ iconName: 'Edit' }} className="boutonEditionProgramme" title="Modifier le programme" onClick={() => this._onAffichePanelProgramme()} />
                                    </Stack>
                                </Stack>
                                {this.state.programme.dateAbandon && <div className="badge badge-warning badgeAbandon" title={Scriba.date().stringDateFormatCourt(this.state.programme.dateAbandon)}>Abandon</div>}
                            </div>
                        </div>
                        <div className="ms-Grid-row divEncartIdentificationSecondaireProgramme">
                            {/* Image */}
                            {/*this.state.chargementPhotosEnCours ?
                                <SpinnerChargement label="Chargement des perspectives..." /> :
                                this.state.photos.length > 0 ?
                                    this.state.photos.length > 1 ?
                                        <Gallery images={this.state.photos} enableImageSelection={false} />
                                        : <img src={this.state.photos[0].src} alt={this.state.photos[0].caption} className="imgIdentificationProgramme" />
                                    : "Aucune image disponible"
                            */}
                            <CarouselProgramme idProgramme={this.state.programme.idProgramme} avecImageParDefaut avecLegende />
                        </div>
                    </div>
                </div>

                <div className="ms-Grid-col ms-sm12 ms-lg4">
                    {/* Section : Administratif */}
                    <div className={this.state.expandBlocAdministratif ? "ms-Grid blocIdentification blocProgrammeAdministratifExpand" : "ms-Grid blocIdentification blocProgrammeAdministratif"}>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12">
                                <Stack horizontal horizontalAlign="space-between">
                                    <div className="titreEncart">
                                        Administratif
                                    </div>
                                    <IconButton name="btnEditAdministratif" iconProps={{ iconName: 'Edit' }} title="Modifier" onClick={this._onAffichePanelProgrammeAdministratif} />
                                </Stack>
                            </div>
                        </div>
                        <Icon
                            className="iconeCollapse"
                            title={this.state.expandBlocAdministratif ? "Masquer" : "Afficher"}
                            onClick={() => this.setState({ expandBlocAdministratif: !this.state.expandBlocAdministratif })}
                            iconName={this.state.expandBlocAdministratif ? "ChevronUp" : "ChevronDown"}
                        />
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12">
                                {this.state.programme.directeurProgrammeAdjoint ?
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Directeur programme adjoint :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.programme.directeurProgrammeAdjoint}</div>
                                    </div>
                                    : null
                                }
                                {this.state.programme.directeurProgramme ?
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Directeur programme :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.programme.directeurProgramme}</div>
                                    </div>
                                    : null
                                }
                                {this.state.programme.directeurOperationnel ?
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Directeur opérationnel :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.programme.directeurOperationnel}</div>
                                    </div>
                                    : null
                                }
                                {this.state.programme.directeurTerritorial ?
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Directeur territorial :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">{this.state.programme.directeurTerritorial}</div>
                                    </div>
                                    : null
                                }
                                {!!this.state.responsablesProgramme && !!this.state.responsablesProgramme.length &&
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12 ms-md6">Responsable(s) programme :</div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6">
                                            {this.state.responsablesProgramme.map((responsable, index) => <div key={index}>{responsable}</div>)}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    {/* Section : planning */}
                    <div className={this.state.expandBlocPlanning ? "blocIdentification niveau2 blocProgrammePlanningExpand" : "blocIdentification niveau2 blocProgrammePlanning"}>
                        <Stack horizontal horizontalAlign="space-between">
                            <div className="titreEncart">
                                <Icon iconName="Calendar" className="mr-2" />Planning
                            </div>
                            <IconButton name="btnEditProgrammePlanning" iconProps={{ iconName: 'Edit' }} title="Modifier" onClick={this._onAffichePanelProgrammePlanning} />
                        </Stack>
                        <Icon
                            className="iconeCollapse"
                            title={this.state.expandBlocPlanning ? "Masquer" : "Afficher"}
                            onClick={() => this.setState({ expandBlocPlanning: !this.state.expandBlocPlanning })}
                            iconName={this.state.expandBlocPlanning ? "ChevronUp" : "ChevronDown"}
                        />
                        {this._renderPlanningProgramme()}
                        <hr />
                        {this._renderPlanningsTranchesTravaux()}
                    </div>
                </div>
            </div>
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                    {/* Section : Opérations */}
                    <div className="ms-Grid blocIdentification niveau3">
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12">
                                <Stack horizontal horizontalAlign="space-between">
                                    <div className="titreEncart">
                                        <Icon iconName="Home" className="mr-2" />Opérations
                                    </div>
                                </Stack>
                            </div>
                        </div>
                        <DetailsList
                            items={this.state.listOperations}
                            selectionMode={SelectionMode.none}
                            columns={this.columns}
                        />
                    </div>
                </div>
            </div>
        </div>;
    }

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du programme en cours'
        });

        var chargementFicheIdentification = DataOperation._chargementFicheIdentificationProgramme();

        chargementFicheIdentification.then(responseFetch => {
            if (responseFetch.codeRetour === 1) {
                // Pas de programme dans le périmètre, on redirige vers la liste des opérations
                this.setState({ redirectionVersListeOperations: true });
            }
            else {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let retourData = responseFetch.reponseAPIobjet;
                    let stateTemp = {};

                    if (retourData !== null) {
                        let listeDesPromisesAExecuter = [];
                        let programme = retourData[0];
                        //let photosProgramme = retourData[7];

                        stateTemp.programme = programme;
                        stateTemp.region = retourData[1];
                        stateTemp.agence = retourData[2];
                        stateTemp.periodeOuverture = retourData[3];
                        stateTemp.listOperations = retourData[4];
                        stateTemp.listTrancheTravaux = retourData[5];
                        stateTemp.listEngagementsParTrancheTravauxEtSousProduit = retourData[6];
                        stateTemp.photos = [];
                        //stateTemp.chargementPhotosEnCours = (photosProgramme.length > 0 ? true : false);
                        stateTemp.responsablesProgramme = retourData[8];
                        stateTemp.listOperisNomenclature = retourData[9];

                        let chargementCycleOperation = DataOperation._chargementFicheIdentification_CycleOperationParProgramme(programme);
                        listeDesPromisesAExecuter.push(chargementCycleOperation.then(responseFetch => {
                            this._onChargementCycleOperation(responseFetch, this, stateTemp);
                        }));

                        Promise.all(listeDesPromisesAExecuter).then(() => { Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp); });

                        //if (photosProgramme.length > 0) {
                        //    photosProgramme.forEach(p => {
                        //        this._chargementPerspectiveOperation(p.rowGUID, p.typeDocument, p.nomCommercial);
                        //    });
                        //}
                    }
                    else {
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            }
        });
    }

    //_chargementPerspectiveOperation(rowGUID, typeDocument, nomCommercial) {
    //    let _chargementFicheOperation_PhotoTailleReelle = DataOperation._chargementFicheOperation_PhotoTailleReelle(rowGUID);

    //    _chargementFicheOperation_PhotoTailleReelle
    //        .then(responseFetch => {
    //            let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

    //            if (retourVerif === null) {
    //                let objetData = responseFetch.reponseAPIobjet;
    //                let listPhotos = [...this.state.photos];

    //                listPhotos.push({
    //                    src: `data:image/png;base64,${objetData.fileData}`,
    //                    thumbnail: `data:image/png;base64,${objetData.fileData}`,
    //                    //thumbnailWidth: 320,
    //                    //thumbnailHeight: 212,
    //                    tags: [{ value: typeDocument, title: typeDocument }],
    //                    caption: nomCommercial
    //                });

    //                this.setState({ photos: listPhotos, chargementPhotosEnCours: false });
    //            }
    //            else {
    //                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
    //            }
    //        });
    //}

    _onChargementCycleOperation = (responseFetch, _this, stateTemp) => {
        let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, _this);

        if (retourVerif === null) {
            let objetData = responseFetch.reponseAPIobjet;
            let listCycleOperationTrav = [];

            if (objetData !== null) {
                objetData.forEach(function (cycle, index) {
                    listCycleOperationTrav.push({
                        numEtape: (index + 1),
                        icone: (!!cycle.dateAffichee ? 'CompletedSolid' : 'PageRight'),
                        nomEtape: cycle.libelle,
                        sousTitre: (!!cycle.dateAffichee ? Scriba.date().stringDateFormatLong(cycle.dateAffichee) : ''),
                        // KP - 1627 - 23/09/2021 - Pas de cycles Programme en BDD ; donc pas de date de modification
                        //tooltip: (!!cycle.modifierLe ? `Mis à jour le ${Scriba.date().stringDateHeureFormatCourt(cycle.modifierLe)}` : ''),
                        onClick: _this._togglePanelCycleOperation(true, cycle.idCycleOperation, false)
                    });
                });
            }

            stateTemp.listCycleOperation = listCycleOperationTrav;
        }
        else {
            Immocom.onTraitementErreurAvecState(_this, stateTemp, retourVerif, responseFetch);
        }
    }

    _onAffichePanelProgrammeNomenclature = () => {
        this.setState({
            onAffichePanelProgrammeNomenclature: true,
            onPeutChargerLeComposantFicheProgrammeNomenclature: true
        });
    };

    _onAfficheListeProgrammeNomenclatureOperis = () => {
        this.setState({
            onAfficheListeProgrammeNomenclatureOperis: true
        });
    }

    _onCachePanelProgrammeNomenclature = () => {
        if (this.state.onAffichePanelProgrammeNomenclature) {
            this.setState({
                onAffichePanelProgrammeNomenclature: false,
                onPeutChargerLeComposantFicheProgrammeNomenclature: false
            });

            this._chargementDonnees();
        }
    };

    _onEnregistrementNomenclature = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Rechargement du périmètre en cours"
        });

        Data._onRechargementDeMonCompte().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                localStorage.setItem("onRemontePerimetreSelectionneParProgramme", "true");
                this.setState({ redirectionVersListeOperations: true }); // Rustine : permet le refresh du périmètre
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    _onAffichePanelProgrammePlanning = () => {
        this.setState({
            onAffichePanelProgrammePlanning: true,
            onPeutChargerLeComposantFicheProgrammePlanning: true
        });
    };

    _onCachePanelProgrammePlanning = () => {
        if (this.state.onAffichePanelProgrammePlanning) {
            this.setState({
                onAffichePanelProgrammePlanning: false,
                onPeutChargerLeComposantFicheProgrammePlanning: false
            });

            this._chargementDonnees();
        }
    };

    _onAffichePanelTrancheTravaux = (idProgramme, idTrancheTravaux, idRegion, idAgence) => {
        this.setState({
            onAffichePanelTrancheTravaux: true,
            idProgrammeSelectionne: idProgramme,
            idTrancheTravauxSelectionne: idTrancheTravaux,
            idRegionTrancheTravaux: idRegion,
            idAgenceTrancheTravaux: idAgence
        });
    };

    _onCachePanelTrancheTravaux = (rechargerLesDonnees) => () => {
        this.setState({
            onAffichePanelTrancheTravaux: false,
            idProgrammeSelectionne: 0,
            idTrancheTravauxSelectionne: 0,
            idRegionTrancheTravaux: 0,
            idAgenceTrancheTravaux: 0
        });

        if (rechargerLesDonnees)
            this._chargementDonnees();
    };

    _onAffichePanelProgramme = () => {
        this.setState({
            onAffichePanelProgramme: true
        });
    };

    _onCachePanelProgramme = () => {
        if (this.state.onAffichePanelProgramme) {
            this.setState({
                onAffichePanelProgramme: false
            });

            this._chargementDonnees();
        }
    };

    _onAffichePanelProgrammeAdministratif = () => {
        this.setState({
            onAffichePanelProgrammeAdministratif: true,
            onPeutChargerLeComposantFicheProgrammeAdministratif: true
        });
    };

    _onCachePanelProgrammeAdministratif = () => {
        if (this.state.onAffichePanelProgrammeAdministratif) {
            this.setState({
                onAffichePanelProgrammeAdministratif: false,
                onPeutChargerLeComposantFicheProgrammeAdministratif: false
            });

            this._chargementDonnees();
        }
    };

    _togglePanelCycleOperation = (isOpen, idCycleOperation, rechargerLesDonnees) => () => {
        this.setState(
            {
                onAffichePanelValidationCycleOperation: isOpen,
                selectedIdCycleOperation: idCycleOperation || 0
            },
            rechargerLesDonnees ? this._chargementDonnees : null
        );
    };

    _renderPlanningProgramme = () => {
        const { programme } = this.state;
        const columns = [
            { key: "date", name: "Date", fieldName: "date" },
            { key: "prevue", name: "Prévue", onRender: (item) => Scriba.date().stringDateFormatCourt(item.prevue) },
            { key: "reelle", name: "Réelle", onRender: (item) => Scriba.date().stringDateFormatCourt(item.reelle) }
        ];
        const items = [
            { date: "Perspective", reelle: programme.datePerspective },
            { date: "Développement", reelle: programme.dateDeveloppement },
            { date: "Montage", reelle: programme.dateMontage },
            { date: "Accord comité promesse terrain", reelle: programme.dateAccordComitePromesse },
            { date: "Sign. promesse terrain", prevue: programme.dateSignaturePromessePrevue, reelle: programme.dateSignaturePromesse },
            { date: "Accord comité achat terrain", reelle: programme.dateAccordComiteAchatTerrain },
            { date: "Achat terrain", prevue: programme.dateAchatTerrainPrevue, reelle: programme.dateAchatTerrain },
            { date: "Fin validité sign. promesse terrain", prevue: programme.dateSignaturePromesseFinValiditePrevue, reelle: programme.dateSignaturePromesseFinValidite },
        ];

        return <DetailsList compact columns={columns} items={items} selectionMode={SelectionMode.none} />;
    };

    _rendrerNomenclatureOperis = () => {
        const columns = [
            { key: "societe", name: "Société", fieldName: "societe", minWidth: 60, maxWidth: 60 },
            { key: "entite", name: "Entité", fieldName: "entite", minWidth: 60, maxWidth: 60 },
            { key: "activite", name: "Activité", fieldName: "activite", minWidth: 60, maxWidth: 60 },
            { key: "projet", name: "Projet", fieldName: "projet", minWidth: 60, maxWidth: 60 }
        ];

        return <DetailsList compact columns={columns} items={this.state.listOperisNomenclature} selectionMode={SelectionMode.none} />;
    };

    _onRenderFooterContentNomenclatureOperis = () => {
        return (
            <div>
                <DefaultButton onClick={() => this._onAnnulationNomenclatureOperis()}>Fermer</DefaultButton>
            </div>
        );
    };

    _onAnnulationNomenclatureOperis = () => {
        this.setState({
            onAfficheListeProgrammeNomenclatureOperis: false
        });
        this._chargementDonnees();
    }

    _renderPlanningsTranchesTravaux = () => {
        let content = [];

        this.state.listTrancheTravaux.forEach((tt, index) => {
            const columns = [
                { key: "date", name: "Date", fieldName: "date" },
                { key: "prevue", name: "Prévue", onRender: (item) => Scriba.date().stringDateFormatCourt(item.prevue) },
                { key: "reelle", name: "Réelle", onRender: (item) => Scriba.date().stringDateFormatCourt(item.reelle) }
            ];
            const items = [
                { date: "Dépôt PC", prevue: tt.dateDepotPCPrevue, reelle: tt.dateDepotPC },
                { date: "Obtention PC", prevue: tt.dateObtentionPCPrevue, reelle: tt.dateObtentionPC },
                { date: "Purge PC", prevue: tt.datePurgePCPrevue, reelle: tt.datePurgePC },
                { date: "Accord comité lancement travaux", reelle: tt.dateAccordComiteLancementTravaux },
                { date: "Signature OS travaux", prevue: tt.dateSignatureOSTravauxPrevue, reelle: tt.dateSignatureOSTravaux },
                { date: "Achèvement", prevue: tt.dateAchevementPrevue, reelle: tt.dateAchevement },
            ];

            // Permet d'avoir un séparateur entre les dates liées au PC, et les autres
            // Pour une raison inconnue borderBottom ne fonctionne pas
            const onRenderRow = (props, defaultRender) => {
                if (props && props.itemIndex === 2) {
                    const styles = { root: { borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "rgba(0, 0, 0, 0.1)" } };
                    return defaultRender({ ...props, styles })
                }
                else return defaultRender(props);
            };

            content.push(
                <Fragment key={index}>
                    <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
                        <Stack horizontal verticalAlign="center" gap={5}>
                            <div className="labelTrancheTravaux">{tt.trancheTravaux}</div>
                            {tt.dateAbandon && <div className="badge badge-warning badgeAbandon" title={Scriba.date().stringDateFormatCourt(tt.dateAbandon)}>Abandon</div>}
                        </Stack>
                        <IconButton name="btnEditTrancheTravaux" iconProps={{ iconName: 'Edit' }} title="Modifier la tranche travaux" onClick={() => this._onAffichePanelTrancheTravaux(tt.idProgramme, tt.idTrancheTravaux, tt.idRegion, tt.idAgence)} />
                    </Stack>
                    <div>N° de permis de construire : {tt.numPC}</div>
                    <div>Nom mairie : {tt.nomMairie}</div>
                    <div className="separateur" />
                    <DetailsList
                        compact
                        columns={columns}
                        items={items}
                        onRenderRow={onRenderRow}
                        selectionMode={SelectionMode.none}
                    />
                </Fragment>
            );
        });

        return content;
    }

    _redirectionVersIdentificationOperation = (updatePerimetre, idRegion, idAgence, idProgramme, idOperation) => {
        if (updatePerimetre) {
            const { setPerimetre } = this.context;
            const perimetre = { idRegion, idAgence, idProgramme, idOperation };
            const onSuccess = () => {
                this.setState({ redirectionVersIdentificationOperation: true });
                //localStorage.setItem("onSelectionneOperation", "true"); // KP - 02/01/2023 : n'est plus utilisé
            };
            const onError = (retourVerif, responseFetch) => Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            setPerimetre(perimetre, onSuccess, onError);
        }
        else {
            this.setState({ redirectionVersIdentificationOperation: true });
        }
    };

    componentDidMount() {
        this._chargementDonnees();
    }

    //componentDidUpdate() {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");

    //        this._chargementDonnees();
    //    }
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this._chargementDonnees();
    };

    render = () => {
        const content = this._creationContent();

        if (this.state.redirectionVersIdentificationOperation) {
            return <Redirect to='/Operations/IdentificationOperation' />;
        }
        else if (this.state.redirectionVersListeOperations) {
            return <Redirect to='/Operations/ListeOperations' />;
        }
        else {
            return <Fragment>
                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}
                <Panel
                    isOpen={this.state.onAfficheListeProgrammeNomenclatureOperis}
                    type={PanelType.large}
                    headerText="Nomenclature Opéris"
                    closeButtonAriaLabel="Fermer"
                    onDismiss={() => this._onAnnulationNomenclatureOperis()}
                    onRenderFooterContent={this._onRenderFooterContentNomenclatureOperis}
                >
                    <DetailsListProgrammeNomenclatureOperis
                        idProgramme={this.state.programme.idProgramme}
                        idRegion={this.state.programme.idRegion}
                        idAgence={this.state.programme.idAgence}
                    />
                </Panel>
                <Stack verticalFill>
                    <MessageBars
                        errorMessage={this.state.errorMessage}
                        warningMessage={this.state.warningMessage}
                        onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                        onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                    />
                    <div className="position-relative h-100">
                        <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                            {content}
                        </ScrollablePane>
                    </div>
                </Stack>

                <FicheProgrammeNomenclature
                    programme={this.state.programme}
                    onAffichePanelProgrammeNomenclature={this.state.onAffichePanelProgrammeNomenclature}
                    onEnregistrementFiche={this._onEnregistrementNomenclature}
                    onFermeFicheProgrammeNomenclature={this._onCachePanelProgrammeNomenclature}
                    onPeutChargerLeComposant={this.state.onPeutChargerLeComposantFicheProgrammeNomenclature}
                />

                <FicheProgrammePlanning
                    programme={this.state.programme}
                    onAffichePanelProgrammePlanning={this.state.onAffichePanelProgrammePlanning}
                    onEnregistrementFiche={() => this._onCachePanelProgrammePlanning()}
                    onFermeFicheProgrammePlanning={() => this._onCachePanelProgrammePlanning()}
                    onPeutChargerLeComposant={this.state.onPeutChargerLeComposantFicheProgrammePlanning}
                />

                <FicheProgramme
                    idProgramme={this.state.programme.idProgramme}
                    idRegion={this.state.programme.idRegion}
                    idAgence={this.state.programme.idAgence}
                    isOpen={this.state.onAffichePanelProgramme}
                    onAnnulation={this._onCachePanelProgramme}
                    onEnregistrement={this._onCachePanelProgramme}
                />

                <FicheTrancheTravaux
                    isOpen={this.state.onAffichePanelTrancheTravaux}
                    onAnnulation={this._onCachePanelTrancheTravaux(false)}
                    onEnregistrement={this._onCachePanelTrancheTravaux(true)}
                    idProgramme={this.state.idProgrammeSelectionne}
                    idTrancheTravaux={this.state.idTrancheTravauxSelectionne}
                    idRegion={this.state.idRegionTrancheTravaux}
                    idAgence={this.state.idAgenceTrancheTravaux}
                />

                <FicheProgrammeAdministratif
                    programme={this.state.programme}
                    onAffichePanelProgrammeAdministratif={this.state.onAffichePanelProgrammeAdministratif}
                    onEnregistrementFiche={() => this._onCachePanelProgrammeAdministratif()}
                    onFermeFicheProgrammeAdministratif={() => this._onCachePanelProgrammeAdministratif()}
                    onPeutChargerLeComposant={this.state.onPeutChargerLeComposantFicheProgrammeAdministratif}
                />

                <FicheValidationCycleProgramme
                    idAgence={this.state.programme.idAgence}
                    idCycleOperation={this.state.selectedIdCycleOperation}
                    idProgramme={this.state.programme.idProgramme}
                    idRegion={this.state.programme.idRegion}
                    isOpen={this.state.onAffichePanelValidationCycleOperation}
                    onDismiss={this._togglePanelCycleOperation(false, null, false)}
                    onSave={this._togglePanelCycleOperation(false, null, true)}
                />
            </Fragment>;
        }
    }
}